export default __webpack_public_path__ + "static/media/Snk.e2781036.png";